import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import {styled} from '@mui/system';


const StyledCircularProgress = styled(CircularProgress)({
    color: green[500],
    marginTop: 50,
    marginLeft: '50%',
    marginBottom: 30
});

class ProgressSpinner extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <StyledCircularProgress />
        );
    }
}

ProgressSpinner.propTypes = {};

export default ProgressSpinner;
